import React from "react";
import Header from "../../Partials/Header/Header";
import Footer from "../../Partials/Footer/Footer";

import Body from "./Body";
import Getcertificate from "../../Components/Getcertificate/Getcertificate";

export default class Getcertified extends React.Component {
  render() {
    return (
      <div className="integrator-wrapper">
        <Header />
        <Body />
        <Getcertificate />
        <Footer />
      </div>
    );
  }
}